import { HelpCircle } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';

interface HelpButtonProps {
  className?: string;
}

export function HelpButton({ className }: HelpButtonProps) {
  const { language } = useLanguage();

  // Generate help URL based on current language
  const helpUrl = `/help-${language}.html`;

  return (
    <a
      href={helpUrl}
      className={className}
      title="Help"
      target="_blank"
      rel="noopener noreferrer"
    >
      <HelpCircle className="h-5 w-5" />
    </a>
  );
}
